import React, {Component} from 'react';
import {connect} from 'react-redux';
import ForgotPassword from "../components/forgotPassword";
import {isEmail} from "../helpers/functions";
import {changeUserStateSettings, sendForgotPassword} from "../actions/user";  

class ForgotPasswordHOC extends Component {

    constructor(props){
        super(props);
        this.state = {
            email: '',
            validateMessage: '',
            verified: false
        }
    }

    handleInputChange = (evt) => {
        this.setState({
            ...this.state,
            email: evt.target.value,
            validateMessage: ''
        });
        this.props.changeUserStateSettings('sendForgotPasswordSuccessMsg', '');
        this.props.changeUserStateSettings('sendForgotPasswordFailedMsg', '');
    };

    handleVerify = () => {
        this.setState({
            ...this.state,
            verified: true
        });
    };

    handleExpire = () => {
        this.setState({
            ...this.state,
            verified: false
        });
    };

    handleSubmit = (evt) => {
        evt.preventDefault();
        if (!isEmail(this.state.email)) {
            this.setState({
                ...this.state,
                validateMessage: 'Email is not valid'
            });
            return false;
        }
        if(!this.state.verified){
            this.setState({
                ...this.state,
                validateMessage: 'ReCaptcha validation has failed.'
            });
            return false;
        }
        this.props.sendForgotPassword({
            sendBody: {email: this.state.email}
        })
    };

    onCaptchaLoad = () => {
        return ;
    };

    render(){
        return (
                <ForgotPassword
                    {...this.props}
                    email={this.state.email}
                    validateMessage={this.state.validateMessage}
                    handleInputChange={this.handleInputChange}
                    handleSubmit={this.handleSubmit}
                    handleVerify={this.handleVerify}
                    handleExpire={this.handleExpire}
                    onCaptchaLoad={this.onCaptchaLoad}
                />
        )
    }
}

const mapStateToProps = state => {
    return {
        sendingForgotPassword: state.user.sendingForgotPassword,
        sendForgotPasswordSuccessMsg: state.user.sendForgotPasswordSuccessMsg,
        sendForgotPasswordFailedMsg: state.user.sendForgotPasswordFailedMsg,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        sendForgotPassword: (payload) => {
            dispatch(sendForgotPassword(payload))
        },
        changeUserStateSettings: (payload) => {
            dispatch(changeUserStateSettings(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordHOC);